import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ChiffresCles from '../components/ChiffresCles';
import AnciensClients from '../components/AnciensClients';
import TitreI2C from '../components/TitreI2C';
import NotreJunior from '../components/NotreJunior';
import EtapesProjet from '../components/EtapesProjet';
import NosPartenaires from '../components/NosPartenaires';
import NotreOffre from '../components/NotreOffre';
import Particules from '../components/Particules';

function Home() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="relative z-20">
        <Header variant="light"/>
      </div>

      <div className="relative h-[650px] bg-gray-900 flex flex-col justify-between overflow-hidden">
        <Particules style={{ position: 'absolute', inset: 0, zIndex: 0 }} />
        <div className="relative z-10 h-full flex flex-col justify-center items-evenly gap-20">
          <h1 className="px-6 w-auto text-center text-5xl font-extrabold text-white dark:text-blanc-sombre">Placer l'Homme au cœur de l'innovation</h1>
          <div className="flex flex-wrap justify-center gap-4 md:justify-evenly">
            <button className="bg-white dark:bg-bleu-footer text-sky-800 dark:text-blanc-sombre py-4 px-5 font-bold rounded-lg" onClick={() => {document.getElementById('notre_offre').scrollIntoView({ behavior: 'smooth' });}}>
              Notre offre de prestation
            </button>
            <button className="bg-white dark:bg-bleu-footer text-sky-800 dark:text-blanc-sombre py-4 px-5 font-bold rounded-lg" onClick={() => navigate('/contact')}>
              Prendre un rendez-vous
            </button>
          </div>
        </div>
        <img src="/images/ellipse.png" alt="Ellipse" className="relative w-screen z-10 transition-all duration-300 dark:[filter:sepia(1)_saturate(2000%)_hue-rotate(180deg)_brightness(0.3)]"/>
      </div>

      <div className="relative z-10 dark:bg-fond-sombre py-[30px]">
        <TitreI2C/>
        <div className="flex flex-col justify-even gap-[76px] ">
          <NotreJunior/>
          <ChiffresCles/>
          <NosPartenaires/>
          <EtapesProjet/>
          <NotreOffre/>
          <AnciensClients/>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default Home;